export default __webpack_public_path__ + "static/media/image3.d6798eb5.svg";